module.exports = __webpack_public_path__ + "img/icone0-1024x1024.a7cd8259.png";